import elementInViewport from "./helpers/elementInViewport";

const adjustScrollDownPosition = () => {
    const scrollDownElement = document.querySelector('.ume-starter-scroll-to-content');
    if (scrollDownElement instanceof HTMLElement) {
        let coverBlock = document.querySelector('.wp-block-cover');
        if (false === elementInViewport(coverBlock)) {
            scrollDownElement.remove();
            return;
        }
        const header = document.querySelector('header.header');
        let headerHeight = 0;
        if (header instanceof HTMLElement) {
            headerHeight = header.offsetHeight;
        }

        let newTopValue = coverBlock.offsetHeight;


        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        let scrollDownElementHeight = scrollDownElement.offsetHeight;
        let scrollerAddOn = vw > 800 ? 50 : 30
        let sumValue = newTopValue + headerHeight - (scrollDownElementHeight / 2) - scrollerAddOn;


        if (sumValue < window.innerHeight) {
            scrollDownElement.style.top = sumValue + 'px';
        }
        if (sumValue >= window.innerHeight) {
            scrollDownElement.style.top = (newTopValue - scrollerAddOn + 25) + 'px';
        }
        scrollDownElement.classList.add('ume-starter-scroll-to-content-visible')


    }
}
export default adjustScrollDownPosition;